/**
 * ConfirmDialog – yes/no confirmation dialog built on BaseDialog.
 * Triggered from jQuery via openReactBaseDialog('ConfirmDialog', { ... })
 */

import React from 'react'
import { BaseDialog } from '../base-components/BaseDialog'

export interface ConfirmDialogProps {
    showDialog: boolean
    onClose?: () => void
    /** Called when the confirm (yes) button is clicked */
    onConfirm?: () => void
    /** Dialog header title */
    title?: string
    /** Dialog body text or React node */
    content?: React.ReactNode | string
    /** Label for the confirm button (default: "Yes") */
    confirmLabel?: string
    /** Label for the cancel button (default: "No") */
    cancelLabel?: string
    /** Dialog size preset */
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl'
}

export function ConfirmDialog({
    showDialog,
    onClose,
    onConfirm,
    title,
    content,
    confirmLabel = 'Yes',
    cancelLabel = 'No',
    size = 'xs',
}: ConfirmDialogProps) {
    return (
        <BaseDialog
            showDialog={showDialog}
            onClose={onClose}
            onSave={onConfirm}
            headerContent={title}
            bodyContent={content}
            saveLabel={confirmLabel}
            cancelLabel={cancelLabel}
            size={size}
        />
    )
}
